import { Link } from 'react-router-dom';
import JsonLd from '../../components/seo/JsonLd';
import SEOHead from '../../components/seo/SEOHead';

export default function TermsPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/terms#webpage`,
    url: `${siteUrl}/terms`,
    name: '利用規約 - AIいのちゃん',
    description: 'AIいのちゃんの利用規約をご確認ください。',
    inLanguage: 'ja',
    isPartOf: {
      '@id': `${siteUrl}/#website`
    }
  };

  return (
    <>
      <SEOHead 
        title="利用規約 - AIいのちゃん"
        description="AIいのちゃんの利用規約をご確認ください。"
        canonical={`${siteUrl}/terms`}
      />
      <JsonLd data={jsonLdData} />
      
      <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
        {/* ... existing code ... */}
      </div>
    </>
  );
}